import { useState } from 'react';

interface LoginFormProps {
  loading?: boolean;
  error?: string | null;
  onSubmit(username: string, password: string): Promise<void>;
}

export function LoginForm({ loading = false, error, onSubmit }: LoginFormProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);

  const disabled = loading || submitting;

  return (
    <main className="auth-screen">
      <form
        className="auth-panel"
        onSubmit={(event) => {
          event.preventDefault();
          setLocalError(null);
          setSubmitting(true);
          onSubmit(username, password)
            .catch((err) => setLocalError(err instanceof Error ? err.message : '登录失败'))
            .finally(() => setSubmitting(false));
        }}
      >
        <div className="auth-heading">
          <h1>Apollo Admin</h1>
          <p>账号登录</p>
        </div>
        <label className="auth-field">
          <span>用户名</span>
          <input
            autoComplete="username"
            value={username}
            disabled={disabled}
            onChange={(event) => setUsername(event.target.value)}
          />
        </label>
        <label className="auth-field">
          <span>密码</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            disabled={disabled}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {(localError || error) && <div className="auth-error">{localError || error}</div>}
        <button className="auth-submit" type="submit" disabled={disabled || !username.trim() || !password}>
          {submitting ? '登录中...' : '登录'}
        </button>
      </form>
    </main>
  );
}
